<template>
  <div class="custom-cps">
    <el-dialog v-if="customData && customData.code != 'NO_EXIST'" title="海关总署舱单" :visible.sync="visible" :before-close="closeDialog" width="1020px" :close-on-click-modal="false">
      <div>
        <div class="table-part">港区信息</div>
        <WTable :WTableOpts="WTableOpts1"></WTable>
        <div class="table-part" style="margin-top:24px">提单信息</div>
        <WTable :WTableOpts="WTableOpts2"></WTable>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="submit-btn" @click="closeDialog">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-else title="海关总署舱单" :visible.sync="visible" :before-close="closeDialog" width="360px" :close-on-click-modal="false">
      <div class="txt">暂无数据，总署舱单回执速度相比亿通舱单要慢，请稍后再试！</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="submit-btn" @click="closeDialog">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "CustomCps",
  props: {
    customData: {
      type: Object,
      default: () => {}
    },
    visible: Boolean
  },
  data() {
    return {
      WTableOpts1: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'customsCode', label: '关区代码'},
          { prop: 'shippingType', label: '运输方式'},
          { prop: 'blType', label: '提运单类型'},
          { prop: 'unCode', label: '运输工具名称'},
          { prop: 'voyageNum', label: '航班/航次'},
          { prop: 'inMark', label: '进口抵港确报标志'}
        ]
      },
      WTableOpts2: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'blNum', label: '提运单'},
          { prop: 'date', label: '进出境日期'},
          { prop: 'number', label: '件数'},
          { prop: 'weight', label: '重量'},
          { prop: 'tallyStatus', label: '理货状态'},
          { prop: 'outMark', label: '出口运抵状态'}
        ]
      },
    }
  },
  created() {
    this.WTableOpts1.data = [this.customData.data]
    this.WTableOpts2.data = [this.customData.data]
    this.getCustomCpsData()
  },
  methods: {
    // 关闭
    closeDialog(){
      this.$emit("closeDialog")
    },
    //获取海关总署舱单信息
    getCustomCpsData(){
      if(this.manifestSn){
        // httpAjax({
        //   url: '/services/apps/trace/ocean/new/getManifest?manifestSn='+this.manifestSn,
        //   method: 'get',
        // }).then((response) => {
        //   if (response.success) {
        //     let arr = [];
        //     arr.push(response.data);
        //     this.tableData = arr;
        //   } else {
        //     this.$message({
        //       message: response.msg, type: 'error'
        //     })
        //   }
        // })
      }
    },
  }
}
</script>

<style scoped lang="less">
.custom-cps {
  font-size: 14px;
  .table-part {
    height: 36px;
    background: linear-gradient(90deg, #eaf4fe 0%, rgba(198, 225, 253, 0) 100%);
    border-radius: 4px;
    line-height: 36px;
    padding-left: 24px;
    margin-bottom: 24px;
  }
  .submit-btn {
    width: 88px;
    height: 32px;
  }
  .txt {
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }
}
</style>